import PropTypes from 'prop-types'
import styled from 'styled-components'

import BaseHamburger from './Hamburger.base'

const BlueHamburger = styled(BaseHamburger)`
  stroke: ${props => props.theme.colors.rocketBlue};
`

BlueHamburger.propTypes = {
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      white: PropTypes.string
    })
  })
}

/** @component */
export default BlueHamburger



// WEBPACK FOOTER //
// ./src/core/icons/Hamburger/BlueHamburger.js